import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/691a8a71decb2500146c656b/pirateers_elite/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/691a8a71decb2500146c656b/pirateers_elite/src/app/legacy-heritage/components/LegacyInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/691a8a71decb2500146c656b/pirateers_elite/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/691a8a71decb2500146c656b/pirateers_elite/src/components/ui/AppIcon.tsx");
